import * as React from 'react';
import { memo } from 'react';

import styled from 'styled-components';

export interface IStoriesGuestTemplate {
  children: React.ReactElement;
}

export const StoriesGuestTemplate = memo(
  ({ children }: IStoriesGuestTemplate) => (
    <Paper>
      <Wrapper>{children}</Wrapper>
    </Paper>
  ),
);

export const Paper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--k-bg-f2f5f9);
`;

const Wrapper = styled.div`
  display: inherit;
  align-items: inherit;
  justify-content: inherit;
  box-shadow: 0px 3px 9px var(--k-shadow-e1e2e6-a480);
`;
